export default __webpack_public_path__ + "static/media/ATSbanner.1d79a6b9.png";